// Rota raiz "/" (sem slug): o cardápio é sempre acessado por
// cardapio.vittogestao.com.br/<slug>. Sem slug não há o que mostrar — página
// amigável, sem erro cru.
export function LandingState() {
  return (
    <div className="state" role="status">
      <div className="emoji" aria-hidden="true">
        📱
      </div>
      <h2>Escaneie o QR da mesa</h2>
      <p>
        Este é o cardápio digital do Vitto. Aponte a câmera para o QR Code do estabelecimento para
        abrir o cardápio dele.
      </p>
    </div>
  );
}
